import YesNoQuestionPage from "@components/YesNoQuestionPage"

export default function HairstyleExperimentingLookPage() {
  return <YesNoQuestionPage translationKey="experimentingLookHairstyle" />
}
